import { render, staticRenderFns } from "./ExtraCustomerPreviewCommand.vue?vue&type=template&id=331d3b18&scoped=true&"
import script from "./ExtraCustomerPreviewCommand.vue?vue&type=script&lang=ts&"
export * from "./ExtraCustomerPreviewCommand.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraCustomerPreviewCommand.vue?vue&type=style&index=0&id=331d3b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331d3b18",
  null
  
)

export default component.exports